module.exports = __webpack_public_path__ + "static/media/front.fd38f4e5.jpg";